import { createFileRoute, redirect } from "@tanstack/react-router";

/** Legacy slug — permanent redirect to the canonical EN URL. */
export const Route = createFileRoute("/mentoring")({
  beforeLoad: () => {
    throw redirect({ to: "/en/mentoring", statusCode: 301 });
  },
});
